import { useState } from 'react';
import { hot } from 'react-hot-loader';
import LinkExternal from '../components/Link/LinkExternal';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import Team from '../components/Team';
import {
  discordUrl, syaConceptUrl, caravanStudioUrl, spectreStudiosUrl,
} from '../configs';

// PARTNERS images
import partnerSpectreStudiosImg from '../assets/images/partner/spectre-studios-logo.png';
import partnerSpectreStudiosX2Img from '../assets/images/partner/spectre-studios-logo@2x.png';
import partnerSyaConceptImg from '../assets/images/partner/sya-concept-logo.png';
import partnerSyaConceptX2Img from '../assets/images/partner/sya-concept-logo@2x.png';
import partnerCaravanImg from '../assets/images/partner/caravan-logo.png';
import partnerCaravanX2Img from '../assets/images/partner/caravan-logo@2x.png';

// TEAM images
// Dev Patel
import team1PosterImg from '../assets/images/team/team-1@2x.png';
import team1PosterHdImg from '../assets/images/team/team-1@2x.png';
import team1PhotoImg from '../assets/images/team/photo-1@2x.png';
import team1PhotoHdImg from '../assets/images/team/photo-1@2x.png';

// Tilda Cobham-Hervey
import team2PosterImg from '../assets/images/team/team-2@2x.png';
import team2PosterHdImg from '../assets/images/team/team-2@2x.png';
import team2PhotoImg from '../assets/images/team/photo-2@2x.png';
import team2PhotoHdImg from '../assets/images/team/photo-2@2x.png';

// Natalya Pavchinskaya
import team3PosterImg from '../assets/images/team/team-3@2x.png';
import team3PosterHdImg from '../assets/images/team/team-3@2x.png';
import team3PhotoImg from '../assets/images/team/photo-3@2x.png';
import team3PhotoHdImg from '../assets/images/team/photo-3@2x.png';

// Jomon Thomas
import team4PosterImg from '../assets/images/team/team-4@2x.png';
import team4PosterHdImg from '../assets/images/team/team-4@2x.png';
import team4PhotoImg from '../assets/images/team/photo-4@2x.png';
import team4PhotoHdImg from '../assets/images/team/photo-4@2x.png';

// Aleksandr Shlemin
import team5PosterImg from '../assets/images/team/team-5@2x.png';
import team5PosterHdImg from '../assets/images/team/team-5@2x.png';
import team5PhotoImg from '../assets/images/team/photo-5@2x.png';
import team5PhotoHdImg from '../assets/images/team/photo-5@2x.png';

// Konstantin Vinogradov
import team6PosterImg from '../assets/images/team/team-6@2x.png';
import team6PosterHdImg from '../assets/images/team/team-6@2x.png';
import team6PhotoImg from '../assets/images/team/photo-6@2x.png';
import team6PhotoHdImg from '../assets/images/team/photo-6@2x.png';

// Chris Lie
import team7PosterImg from '../assets/images/team/team-7@2x.png';
import team7PosterHdImg from '../assets/images/team/team-7@2x.png';
import team7PhotoImg from '../assets/images/team/photo-7@2x.png';
import team7PhotoHdImg from '../assets/images/team/photo-7@2x.png';

import './ScreenTeam.scss';

import ReactPixel from 'react-facebook-pixel';


function ScreenTeam() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  const [state, setState] = useState({ hover: false });

  return (
    <section className="section-team" id="team">
      <br />
      <br />
      <br />

      <div className="container">
        <div className="row">
          <div className="col-lg-9 order-2 order-lg-1 relative">
            <div className="shad shad-1">
              <span></span>
              <div>nft project team</div>
            </div>
            {/*<div className="shad shad-2">
              <span></span>
              <div>character and shorfilm created by</div>
            </div>*/}
            <div className="row no-gutters">
              <div className="col-auto">
                <Team
                  name={<>Aleksandr <br />Shlemin</>}
                  twitter="https://twitter.com/RoborovskiNFT"
                  telegram="https://t.me/xttzer"
                  photo={team5PosterImg} photohd={team5PosterHdImg}
                  poster={team5PhotoImg} posterhd={team5PhotoHdImg}
                />
              </div>
              <div className="col-auto">
                <Team
                  name={<>Natalya <br />Pavchinskaya</>}
                  imdb="https://www.imdb.com/name/nm8847254/"
                  instagram="https://www.instagram.com/qualitylight/"
                  photo={team3PosterImg} photohd={team3PosterHdImg}
                  poster={team3PhotoImg} posterhd={team3PhotoHdImg}
                />
              </div>
              <div className="col-auto">
                <Team
                  name={<>Daniel <br />Horvath</>}
                  instagram="https://www.instagram.com/daniel.horvath/"
                  twitter="https://twitter.com/Daniel_Horvath_"
                  photo={team6PosterImg} photohd={team6PosterHdImg}
                  poster={team6PhotoImg} posterhd={team6PhotoHdImg}
                />
              </div>
              <div className="col-auto">
                <Team
                  name="Chris Lie"
                  instagram="https://www.instagram.com/chrisliecaravan/"
                  twitter="https://mobile.twitter.com/chrisliecaravan"
                  photo={team7PosterImg} photohd={team7PosterHdImg}
                  poster={team7PhotoImg} posterhd={team7PhotoHdImg}
                  horizontal="1"
                />
              </div>
              {/*<div className="col-auto">
                <Team
                  name="Dev Patel"
                  imdb="https://www.imdb.com/name/nm2353862/"
                  photo={team1PosterImg} photohd={team1PosterHdImg}
                  poster={team1PhotoImg} posterhd={team1PhotoHdImg}
                />
              </div>
              <div className="col-auto">
                <Team
                  name={<>Tilda <br />Cobham-Hervey</>}
                  imdb="https://www.imdb.com/name/nm5315479/"
                  photo={team2PosterImg} photohd={team2PosterHdImg}
                  poster={team2PhotoImg} posterhd={team2PhotoHdImg}
                />
              </div>
              <div className="col-auto">
                <Team
                  name={<>Jomon <br className='d-lg-none' />Thomas</>}
                  imdb="https://www.imdb.com/name/nm3289797/"
                  photo={team4PosterImg} photohd={team4PosterHdImg}
                  poster={team4PhotoImg} posterhd={team4PhotoHdImg}
                />
              </div>

              {!isMobile && <div className="col-lg">
                <p className="desc">We are a collaborative of creators committed to gripping the world with gorgeous visuals and impactful stories.</p>
              </div>}*/}
            </div>
          </div>

          <div className="col-lg-3 order-1 order-lg-2">
            <div className="pre-title"><span>team</span></div>
            <h2 className="title"><span>Nothing</span> falls short of our ambitions</h2>

            {isMobile && <p className="desc">We are a collaborative of creators committed to gripping the world with gorgeous visuals and impactful stories.</p>}

            {!isMobile && <div className="partners">
              <div className="partner__img partner__img--1">
                <LinkExternal href={spectreStudiosUrl}>
                  <img
                    className="img-responsive" width="200" height="100" alt="" title=""
                    src={partnerSpectreStudiosImg}
                    srcSet={`${partnerSpectreStudiosX2Img} 2x`}
                  />
                </LinkExternal>
              </div>
              <div className="partner__img partner__img--2">
                <LinkExternal href={syaConceptUrl}>
                  <img
                    className="img-responsive" width="200" height="100" alt="" title=""
                    src={partnerSyaConceptImg}
                    srcSet={`${partnerSyaConceptX2Img} 2x`}
                  />
                </LinkExternal>
              </div>
              <div className="partner__img partner__img--3">
                <LinkExternal href={caravanStudioUrl}>
                  <img
                    className="img-responsive" width="200" height="100" alt="" title=""
                    src={partnerCaravanImg}
                    srcSet={`${partnerCaravanX2Img} 2x`}
                  />
                </LinkExternal>
              </div>
            </div>}
          </div>
        </div>

        {isMobile && <div className="partners">
          <div className="partner__img partner__img--1">
            <LinkExternal href={spectreStudiosUrl}>
              <img
                className="img-responsive" width="200" height="100" alt="" title=""
                src={partnerSpectreStudiosImg}
                srcSet={`${partnerSpectreStudiosX2Img} 2x`}
              />
            </LinkExternal>
          </div>
          <div className="partner__img partner__img--2">
            <LinkExternal href={syaConceptUrl}>
              <img
                className="img-responsive" width="200" height="100" alt="" title=""
                src={partnerSyaConceptImg}
                srcSet={`${partnerSyaConceptX2Img} 2x`}
              />
            </LinkExternal>
          </div>
          <div className="partner__img partner__img--3">
            <LinkExternal href={caravanStudioUrl}>
              <img
                className="img-responsive" width="200" height="100" alt="" title=""
                src={partnerCaravanImg}
                srcSet={`${partnerCaravanX2Img} 2x`}
              />
            </LinkExternal>
          </div>
        </div>}

        <LinkExternal href={discordUrl}>
          <div
            id='joinDiscord'
            onClick={() => ReactPixel.track('Lead')}
            className={state.hover ? "join-btn animate__animated animate__headShake" : "join-btn"}
            onMouseOver={() => setState({ hover: true })}
            onMouseOut={() => setState({ hover: false })}
          >
            <span>Join the Roborovski Revolution!</span>
          </div>
        </LinkExternal>
      </div>
    </section>
  );
};

export default hot(module)(ScreenTeam);
